module.exports = __webpack_public_path__ + "img/highSpeedRail-3.ff28fac4.jpg";